import React, { useState, useEffect, useRef } from "react";
import { Nav, Navbar } from "react-bootstrap";
import styles from "./TabsStyles.module.scss";
import {
  ArrowLeft,
  ArrowRight,
} from "../../../modules/default-svg";
import DropDown from "../../../components/controls/dropdown/DropdownFluent";
import Modal from "../../../../src/components/controls/modal/Modal";

const Tabs = (props) => {
  const {
    selectedTab,
    setSelectedTab,
    type,
    projectAppendices,
    setSelectedProjectAppendix,
    onProjectAppendixDelete
  } = props;
  const [projectAppendix, setprojectAppendix] = useState(null);
  const [project_Appendices, setProject_Appendices] = useState([]);
  const [projectAppendicesOptions, setProjectAppendicesOptions] = useState([]);
  const [projectAppendixForDelete, setProjectAppendixForDelete] = useState(null);

  const tabScrollRef = useRef(null);
  const [canScrollTabsLeft, setCanScrollTabsLeft] = useState(false);
  const [canScrollTabsRight, setCanScrollTabsRight] = useState(false);

  const updateTabScrollButtons = () => {
    const el = tabScrollRef.current;
    if (!el) return;
    setCanScrollTabsLeft(el.scrollLeft > 1);
    setCanScrollTabsRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 2);
  };

  useEffect(() => {
    const el = tabScrollRef.current;
    if (!el) return;
    updateTabScrollButtons();
    el.addEventListener("scroll", updateTabScrollButtons);
    window.addEventListener("resize", updateTabScrollButtons);
    let resizeObserver;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(updateTabScrollButtons);
      resizeObserver.observe(el);
    }
    return () => {
      el.removeEventListener("scroll", updateTabScrollButtons);
      window.removeEventListener("resize", updateTabScrollButtons);
      resizeObserver && resizeObserver.disconnect();
    };
  }, [type]);

  const scrollTabs = (direction) => {
    const el = tabScrollRef.current;
    if (!el) return;
    const maxScrollLeft = el.scrollWidth - el.clientWidth;
    const amount = Math.max(150, Math.round(el.clientWidth * 0.8));
    const target = direction === "left"
      ? Math.max(0, el.scrollLeft - amount)
      : Math.min(maxScrollLeft, el.scrollLeft + amount);
    el.scrollTo({ left: target, behavior: "smooth" });
  };

  useEffect(() => {
    if (type === "shiftDetail") {
      if (permissions.includes("Task.View")) {
        setSelectedTab("AssignedTasks");
      } else if (permissions.includes("Shift.View")) {
        setSelectedTab("AssignedShifts");
      } else if (permissions.includes("Leave.View")) {
        setSelectedTab("TimeOff");
      }
    }
  }, []);

  const handleSelectTab = (tab) => {
    setSelectedTab(tab);
  };
  const permissions = localStorage.getItem("permissions");

  useEffect(() => {
    if (projectAppendices) {
      const appendices = [
        ...projectAppendices,
        { id: "new", name: "+ Add New" },
      ];
      setProject_Appendices(appendices);
      const appendicesOptions = appendices.map((appendice) => ({
        value: appendice.id,
        name: appendice.name,
      }));

      setProjectAppendicesOptions(appendicesOptions);
      if (projectAppendix && projectAppendix?.id === "new") {
        setprojectAppendix(projectAppendices.at(-1) || null);
      } else {
        const projectAppendixExists =
          projectAppendix &&
          appendices.find((i) => i.id === projectAppendix.id) != null;
        setprojectAppendix(
          projectAppendixExists
            ? appendices.find((i) => i.id === projectAppendix.id)
            : appendices[0]
        );
      }
    }
  }, [projectAppendices]);

  const resourceOptions = [
    { value: "allocatedResources", name: "Resources" },
    { value: "reshuffleRequests", name: "Capacity Balancer" },
  ];

  const handleSetProjectAppendix = (val) => {
    const selectedAppendix = project_Appendices.find((p) => p.id === val);
    setprojectAppendix(
      selectedAppendix?.id === "new"
        ? { id: "new", name: "" }
        : selectedAppendix
    );
    setSelectedProjectAppendix(selectedAppendix);
  };

  return (
    <>
      {type === "resource" ? (
        <Navbar className={styles.plannerTabWrapper}>
          <Nav className={`${styles.overviewTabItemsWrap} nav-underline`}>
            <Nav.Link
              className={`${styles.overviewTabItem} ${selectedTab === "resourceMonitoring" && styles.active
                }`}
              onClick={() => handleSelectTab("resourceMonitoring")}
            >
              Resource Monitoring
            </Nav.Link>
            {permissions.includes("Shift.View") && (
              <Nav.Link
                className={`${styles.overviewTabItem} ${selectedTab === "shifts" && styles.active
                  }`}
                onClick={() => handleSelectTab("shifts")}
              >
                Shifts
              </Nav.Link>
            )}
          </Nav>
        </Navbar>
      ) : type === "shiftDetail" ? (
        <Navbar className={styles.shiftDetailTabWrapper}>
          <Nav className={`${styles.overviewTabItemsWrap}`}>
            {permissions.includes("Task.View") && (
              <Nav.Link
                className={`${styles.overviewTabItem} ${selectedTab === "AssignedTasks" && styles.active
                  }`}
                onClick={() => handleSelectTab("AssignedTasks")}
              >
                Assigned tasks
              </Nav.Link>
            )}
            {permissions.includes("Shift.View") && (
              <Nav.Link
                className={`${styles.overviewTabItem} ${selectedTab === "AssignedShifts" && styles.active
                  }`}
                onClick={() => handleSelectTab("AssignedShifts")}
              >
                Assigned shifts
              </Nav.Link>
            )}
            {permissions.includes("Leave.View") && (
              <Nav.Link
                className={`${styles.overviewTabItem} ${selectedTab === "TimeOff" && styles.active
                  }`}
                onClick={() => handleSelectTab("TimeOff")}
              >
                Time off
              </Nav.Link>
            )}
          </Nav>
        </Navbar>
      ) : type === "tagLibrary" ? (
        <div className={`overviewTabsContainer mt-3 mb-3 ${styles.tabScrollRow} justify-start`}>
          <Navbar className={styles.overviewTabWrapper}>
            <Nav className={`${styles.overviewTabItemsWrap} nav-underline`}>
              <Nav.Link
                className={`${styles.overviewTabItem} ${selectedTab === "skills" && styles.active
                  }`}
                onClick={() => handleSelectTab("skills")}
              >
                Users Skills
              </Nav.Link>
              <Nav.Link
                className={`${styles.overviewTabItem} ${selectedTab === "industries" && styles.active
                  }`}
                onClick={() => handleSelectTab("industries")}
              >
                Clients Industries
              </Nav.Link>
            </Nav>
          </Navbar>
        </div>
      ) : (
        <div className={`overviewTabsContainer mt-3 mb-3 ${styles.tabScrollRow}`}>
          {canScrollTabsLeft && (
            <button
              type="button"
              className={styles.tabScrollBtn}
              onClick={() => scrollTabs("left")}
              aria-label="Scroll tabs left"
            >
              <ArrowLeft />
            </button>
          )}
          <Navbar className={styles.overviewTabWrapper} ref={tabScrollRef}>
            <Nav className={`${styles.overviewTabItemsWrap} nav-underline`}>
              {type === "clients" && (
                <>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "details" && styles.active
                      }`}
                    onClick={() => handleSelectTab("details")}
                  >
                    Details
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "portfolios" && styles.active
                      }`}
                    onClick={() => handleSelectTab("portfolios")}
                  >
                    Portfolios
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "programs" && styles.active
                      }`}
                    onClick={() => handleSelectTab("programs")}
                  >
                    Programs
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "projects" && styles.active
                      }`}
                    onClick={() => handleSelectTab("projects")}
                  >
                    Projects
                  </Nav.Link>
                  {/* <Nav.Link
                    className={`${styles.overviewTabItem} ${
                      selectedTab === "contracts" && styles.active
                    }`}
                    onClick={() => handleSelectTab("contracts")}
                  >
                    Contracts
                  </Nav.Link> */}
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "allocatedResources" && styles.active
                      }`}
                    onClick={() => handleSelectTab("allocatedResources")}
                  >
                    Resources
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "communication" && styles.active
                      }`}
                    onClick={() => handleSelectTab("communication")}
                  >
                    Communication
                  </Nav.Link>
                </>
              )}
              {type === "projects" && (
                <>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "details" && styles.active
                      }`}
                    onClick={() => handleSelectTab("details")}
                  >
                    Details
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "healthStatus" && styles.active
                      }`}
                    onClick={() => handleSelectTab("healthStatus")}
                  >
                    Health Status
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "scopeItem" && styles.active
                      }`}
                    onClick={() => handleSelectTab("scopeItem")}
                  >
                    Scope Items
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "milestones" && styles.active
                      }`}
                    onClick={() => handleSelectTab("milestones")}
                  >
                    Milestones
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "changeRequest" && styles.active
                      }`}
                    onClick={() => handleSelectTab("changeRequest")}
                  >
                    Change Requests
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "risk/Issues" && styles.active
                      }`}
                    onClick={() => handleSelectTab("risk/Issues")}
                  >
                    Risk/Issues
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "decisionLog" && styles.active
                      }`}
                    onClick={() => handleSelectTab("decisionLog")}
                  >
                    Decision Log
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${(selectedTab === "allocatedResources" || selectedTab === "reshuffleRequests") && styles.active
                      }`}
                    onClick={() => handleSelectTab(selectedTab === "reshuffleRequests" ? "reshuffleRequests" : "allocatedResources")}
                  >
                    <div className="flex items-center">
                      <span className="tab-label">
                        {selectedTab === "reshuffleRequests" ? "Capacity Balancer" : "Resources"}
                      </span>
                      <span className="appendix-filter">
                        {(selectedTab === "allocatedResources" || selectedTab === "reshuffleRequests") && (
                          <DropDown
                            options={resourceOptions}
                            onChange={handleSelectTab}
                            defaultVal={`${" "}`}
                          />
                        )}
                      </span>
                    </div>
                  </Nav.Link>
                  {/* <Nav.Link
                    className={`${styles.overviewTabItem} ${
                      selectedTab === "stakeholders" && styles.active
                    }`}
                    onClick={() => handleSelectTab("stakeholders")}
                  >
                    Stakeholders
                  </Nav.Link> */}
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "communication" && styles.active
                      }`}
                    onClick={() => handleSelectTab("communication")}
                  >
                    Communication
                  </Nav.Link>

                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "timeline" && styles.active
                      }`}
                    onClick={() => handleSelectTab("timeline")}
                  >
                    Timeline
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "runbooks" && styles.active
                      }`}
                    onClick={() => handleSelectTab("runbooks")}
                  >
                    Orchestration
                  </Nav.Link>
                  <div className="shrink-0 bg-[#e5e7eb] h-[27px] w-[2px] mx-[3px] mt-[0.4rem]" />
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "cashflow" && styles.active
                      }`}
                    onClick={() => handleSelectTab("cashflow")}
                  >
                    CashFlow (COA)
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "budget" && styles.active
                      }`}
                    onClick={() => handleSelectTab("budget")}
                  >
                    Budget
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "purchaseOrders" && styles.active
                      }`}
                    onClick={() => handleSelectTab("purchaseOrders")}
                  >
                    Purchase Orders
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "invoiceRegistry" && styles.active
                      }`}
                    onClick={() => handleSelectTab("invoiceRegistry")}
                  >
                    Invoice Registry
                  </Nav.Link>
                  <div className="shrink-0 bg-[#e5e7eb] h-[27px] w-[2px] mx-[3px] mt-[0.4rem]" />
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "appendix" && styles.active
                      }`}
                    onClick={() => handleSelectTab("appendix")}
                  >
                    <div className="flex items-center">
                      <span className="tab-label">Appendix</span>

                      <span className="appendix-filter">
                        {projectAppendices?.length > 0 &&
                          selectedTab === "appendix" && (
                            <DropDown
                              options={projectAppendicesOptions}
                              onChange={handleSetProjectAppendix}
                              defaultVal={
                                projectAppendix
                                  ? `- ${projectAppendix.name}`
                                  : " "
                              }
                              onDeleteAction={setProjectAppendixForDelete}
                            />
                          )}
                      </span>
                    </div>
                  </Nav.Link>
                </>
              )}
              {type === "portfolio" && (
                <>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "details" && styles.active
                      }`}
                    onClick={() => handleSelectTab("details")}
                  >
                    Details
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "dashboard" && styles.active
                      }`}
                    onClick={() => handleSelectTab("dashboard")}
                  >
                    Cockpit
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "roadmap" && styles.active
                      }`}
                    onClick={() => handleSelectTab("roadmap")}
                  >
                    Roadmap
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "programs" && styles.active
                      }`}
                    onClick={() => handleSelectTab("programs")}
                  >
                    Programs
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "projects" && styles.active
                      }`}
                    onClick={() => handleSelectTab("projects")}
                  >
                    Projects
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "scopeItems" && styles.active
                      }`}
                    onClick={() => handleSelectTab("scopeItems")}
                  >
                    Scope Items
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "milestones" && styles.active
                      }`}
                    onClick={() => handleSelectTab("milestones")}
                  >
                    Milestones
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "changeRequest" && styles.active
                      }`}
                    onClick={() => handleSelectTab("changeRequest")}
                  >
                    Change Requests
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "risk/Issues" && styles.active
                      }`}
                    onClick={() => handleSelectTab("risk/Issues")}
                  >
                    Risk/Issues
                  </Nav.Link>
                  {/* <Nav.Link
                    className={`${styles.overviewTabItem} ${
                      selectedTab === "contracts" && styles.active
                    }`}
                    onClick={() => handleSelectTab("contracts")}
                  >
                    Contracts
                  </Nav.Link> */}
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "allocatedResources" && styles.active
                      }`}
                    onClick={() => handleSelectTab("allocatedResources")}
                  >
                    Resources
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "communication" && styles.active
                      }`}
                    onClick={() => handleSelectTab("communication")}
                  >
                    Communication
                  </Nav.Link>

                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "budget" && styles.active
                      }`}
                    onClick={() => handleSelectTab("budget")}
                  >
                    Budget
                  </Nav.Link>
                </>
              )}
              {type === "program" && (
                <>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "details" && styles.active
                      }`}
                    onClick={() => handleSelectTab("details")}
                  >
                    Details
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "healthStatus" && styles.active
                      }`}
                    onClick={() => handleSelectTab("healthStatus")}
                  >
                    Health Status
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "projects" && styles.active
                      }`}
                    onClick={() => handleSelectTab("projects")}
                  >
                    Projects
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "scopeItem" && styles.active
                      }`}
                    onClick={() => handleSelectTab("scopeItem")}
                  >
                    Scope Items
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "milestones" && styles.active
                      }`}
                    onClick={() => handleSelectTab("milestones")}
                  >
                    Milestones
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "changeRequest" && styles.active
                      }`}
                    onClick={() => handleSelectTab("changeRequest")}
                  >
                    Change Requests
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "risk/Issues" && styles.active
                      }`}
                    onClick={() => handleSelectTab("risk/Issues")}
                  >
                    Risk/Issues
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "decisionLog" && styles.active
                      }`}
                    onClick={() => handleSelectTab("decisionLog")}
                  >
                    Decision Log
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "allocatedResources" && styles.active
                      }`}
                    onClick={() => handleSelectTab("allocatedResources")}
                  >
                    Resources
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "communication" && styles.active
                      }`}
                    onClick={() => handleSelectTab("communication")}
                  >
                    Communication
                  </Nav.Link>
                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "timeline" && styles.active
                      }`}
                    onClick={() => handleSelectTab("timeline")}
                  >
                    Timeline
                  </Nav.Link>

                  <Nav.Link
                    className={`${styles.overviewTabItem} ${selectedTab === "budget" && styles.active
                      }`}
                    onClick={() => handleSelectTab("budget")}
                  >
                    Budget
                  </Nav.Link>
                </>
              )}
            </Nav>
          </Navbar>
          {canScrollTabsRight && (
            <button
              type="button"
              className={styles.tabScrollBtn}
              onClick={() => scrollTabs("right")}
              aria-label="Scroll tabs right"
            >
              <ArrowRight />
            </button>
          )}
        </div>
      )}

      {projectAppendixForDelete && (
        <Modal
          title={`Delete Project Appendix`}
          body={
            <p className="text-sm-400 subHeading-color">{`Are you sure you want to delete `}<b>{`${projectAppendixForDelete?.name} ?`}</b></p>
          }
          handleCancel={() => setProjectAppendixForDelete(null)}
          handleSave={() => { onProjectAppendixDelete(projectAppendixForDelete?.value); setProjectAppendixForDelete(null) }}
          saveBtnLabel={`Delete`}
          cancelBtnLabel={"Cancel"}
        />
      )}
    </>
  );
};

export default Tabs;
